// Routes of administration — aligned with PrescriptionItem.ROUTE_CHOICES
// in the Django model.
export const ROUTES = Object.freeze([
  { value: 'PO', label: 'PO (oral)' },
  { value: 'IV', label: 'IV (intravenous)' },
  { value: 'IM', label: 'IM (intramuscular)' },
  { value: 'SC', label: 'SC (subcutaneous)' },
  { value: 'SL', label: 'SL (sublingual)' },
  { value: 'PR', label: 'PR (per rectum)' },
  { value: 'PV', label: 'PV (per vagina)' },
  { value: 'INH', label: 'Inhaled' },
  { value: 'TOP', label: 'Topical' },
  { value: 'NAS', label: 'Nasal' },
  { value: 'OPH', label: 'Ophthalmic' },
  { value: 'OTI', label: 'Otic' },
  { value: 'OTHER', label: 'Other' },
])

// Regularly-prescribed PNG primary-care medicines, shown as quick-pick
// chips below the drug search when the search is empty and focused.
// These are search shortcuts — clicking a chip populates the search box
// with the drug name so the live catalogue search returns concrete
// pharmacy-catalogue rows the clinician can then pick from.
//
// Source: PNG National Standard Treatment Guidelines (primary care subset).
// Add/remove entries freely — there's no backend dependency here.
export const COMMON_DRUGS = Object.freeze([
  'Paracetamol',
  'Amoxicillin',
  'Metronidazole',
  'Ciprofloxacin',
  'Erythromycin',
  'Ceftriaxone',
  'Cotrimoxazole',
  'Doxycycline',
  'Chloroquine',
  'Artemether-Lumefantrine',
  'Quinine',
  'Albendazole',
  'Mebendazole',
  'Ivermectin',
  'Praziquantel',
  'ORS',
  'Zinc sulfate',
  'Salbutamol',
  'Prednisolone',
  'Diazepam',
  'Oxytocin',
  'Gentamicin',
])
